export default "__VITE_ASSET__BsgGZVHe__"